import React from "react";
import { translate } from "react-multi-lang";
import "../style/style.scss";
import PostsPaginationLoader from "../../Loader/PostsPaginationLoader";


const OnScreenLoading = ({ loader}) => {
    return (
        <>
            <div style={{
                position: "fixed",
                display: loader ? 'block' : 'none',
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 2,
                cursor: "pointer"
            }} >
                <div style={{
                    position: "absolute",
                    top: '50%',
                    left: '50%',
                    fontSize: "30px",
                    color: 'white',
                    transform: 'translate(-50%,-50%)'

                }}><PostsPaginationLoader/></div>
            </div>
        </>
    );
};

export default translate(OnScreenLoading);
